var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[(_vm.url)?_c('iframe',{staticStyle:{"width":"100%","max-width":"100%","height":"100vh"},attrs:{"src":_vm.url,"sandbox":"allow-forms allow-scripts allow-pointer-lock allow-same-origin allow-top-navigation allow-presentation","allow":"fullscreen","title":"IELTS"}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e0bb3e0a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/IeltsDoc.vue
// module id = 1862
// module chunks = 1